<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8">
                    <el-input placeholder="请输入内容" v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                        <el-option label="菜单ID" :value="1"></el-option>
                        <el-option label="菜单名称" :value="2"></el-option>
                        <el-option label="父级菜单ID" :value="3"></el-option>
                        <el-option label="父级菜单名称" :value="4"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button v-if="$utils.have('/help/menu/list')"  type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button
                type="primary"
                icon="el-icon-circle-plus-outline"
                @click="$refs.addMenu.show()"
                v-if="$utils.have('/help/menu/create')"
                size="small"
                >创建菜单</el-button
            >
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column label="状态" width="80">
                    <template slot-scope="scope">
                        <el-tag size="mini" :type="scope.row.status == -1 ? 'danger' : 'success'">{{ scope.row.status == -1 ?  "隐藏" : "展示"}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="ID" prop="id" width="80"></el-table-column>
                <el-table-column label="名称" prop="title" min-width="270">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="scope.row.title" placement="top">
                            <span class="ellipsis">{{ scope.row.titleStr }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="所属终端" prop="terminalStr" min-width="160"></el-table-column>
                <el-table-column label="页面链接" prop="pageUrl" min-width="270">
                    <template slot-scope="scope">
                        <el-link class="ellipsis" :href="scope.row.pageUrl" target="_blank" >{{scope.row.pageUrl}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="父级菜单ID" prop="pid" width="100">
                    <template slot-scope="scope">
                        {{ scope.row.pid ? scope.row.pid : '无'}}
                    </template>
                </el-table-column>
                <el-table-column label="父级菜单名称" prop="parentTitle" min-width="150">
                    <template slot-scope="scope">
                        {{ scope.row.parentTitle ? scope.row.parentTitle : '无'}}
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" prop="createTime" width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="170">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            icon="el-icon-s-management"
                            @click="$refs.addMenu.show(scope.row)"
                            >管理菜单</el-button>
                        <el-button
                            type="text"
                            size="small"
                            icon="el-icon-s-management"
                            @click="mangeMenu(scope.row)"
                            v-if="$utils.have('/help/entry/list')"
                            >管理词条</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0"
            >
            </el-pagination>
        </div>
        <addMenu ref="addMenu"></addMenu>
    </div>
</template>
<script>
import addMenu from './components/addMenu'

const defaultParams = {
    pageNo: 1,
    searchType: 2,
    searchValue: ''
}
export default {
    components:{
        addMenu
    },
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 2),
                searchValue: this.$route.query.searchValue || ''
            },
            // detailData: null,
            listLoading: true,
            // addMenuVisible: false,
            choseMenu: null
        };
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/help/menu/list",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                        this.dataList.forEach(i =>{
                            i.titleStr = i.title.slice(0, 40);
                            if(i.title && i.title.length > 40){
                                i.titleStr += '...'
                            }
                        })
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize:this.params.pageSize
            }
            this.getDataList();
        },
        //查看
        // view(data) {
        //     this.detailData = data;
        //     this.addMenuVisible = true;
        // },
        // toMenuPage(url){
        //     window.open(url, '_blank');
        // },
        mangeMenu({pid, id, parentTitle, title}){
            this.$router.push({
                name: 'helpMange-mangeMenu', 
                params: {id, pid, parentTitle, title},
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        }
    },
};
</script>
